import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';

class MainHub {
  private connection: HubConnection;
  constructor() {
    this.connection = new HubConnectionBuilder()
      // .configureLogging(LogLevel.Debug)
      .withUrl('/hub/v1/main')
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          if (retryContext.previousRetryCount < 2) { return 0; } // 0ms
          if (retryContext.previousRetryCount < 5) { return 1000; } // 1s
          if (retryContext.previousRetryCount < 10) { return 1000 + Math.random() * 4000; } // 1s - 5s
          if (retryContext.previousRetryCount < 20) { return 5000 + Math.random() * 5000; } // 5s - 10s
          if (retryContext.previousRetryCount < 30) { return 10000 + Math.random() * 20000; } // 10s - 30s
          return 30000 + Math.random() * 30000; // 30s - 60s
        }
      })
      .build();
  }

  public start() {
    this.connection.start().then(() => {
      console.log('Connection started');
    }).catch(err => {
      console.error('Error while starting connection: ' + err);
    });
  }

  public stop() {
    this.connection.stop().then(() => {
      console.log('Connection stopped');
    }).catch(err => {
      console.error('Error while stopping connection: ' + err);
    });
  }

  public onServerId(callback: (serverId: string) => void) {
    this.connection.on('serverId', callback);
  }

  public onStaticContentChanged(callback: () => void) {
    this.connection.on('staticContentChanged', callback);
  }

  public onOrganizationChanged(callback: () => void) {
    this.connection.on('organizationChanged', callback);
  }

  public onIdentityChanged(callback: (userId?: number) => void) {
    this.connection.on('identityChanged', callback);
  }

  public onMasterdataChanged(callback: (tenantId?: number) => void) {
    this.connection.on('masterdataChanged', callback);
  }

  public onSiteMasterdataChanged(callback: (siteId: number) => void) {
    this.connection.on('siteMasterdataChanged', callback);
  }

  public onEmailQueueChanged(callback: (id: number) => void) {
    this.connection.on('emailQueueChanged', callback);
  }

  public onScopeChanged(callback: (scope: string) => void) {
    this.connection.on('scopeDataChanged', callback);
  }

  public onOrderDraftChanged(callback: (siteId: number) => void) {
    this.connection.on('OrderDraftChanged', callback);
  }

  public offOrderDraftChanged(callback?: (siteId: number) => void) {
    if (callback) {
      this.connection.off('OrderDraftChanged', callback);
    } else {
      this.connection.off('OrderDraftChanged');
    }
  }

  public async notifyOthersOrderDraftChanged(siteId: number): Promise<void> {
    try {
      await this.connection.invoke('NotifyOthersOrderDraftChanged', siteId);
    } catch (error) {
      console.error('Error invoking NotifyOthersOrderDraftChanged:', error);
    }
  }
}

export default new MainHub();
